import { PointerSensor, useSensor, useSensors } from "@dnd-kit/core";

export const useDefaultSensors = () =>
  useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 5,
      },
    })
  );